import { render, staticRenderFns } from "./SolutionDetail.vue?vue&type=template&id=b5401842&scoped=true"
import script from "./SolutionDetail.vue?vue&type=script&lang=js"
export * from "./SolutionDetail.vue?vue&type=script&lang=js"
import style0 from "./SolutionDetail.vue?vue&type=style&index=0&id=b5401842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5401842",
  null
  
)

export default component.exports